import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classnames';

import { constructMSAImageUrl } from 'helpers';
import { FILE_NAME_NO_EXT } from 'common/regex';
import marketplace from 'cfg/marketplace.json';

import css from 'styles/components/cart/productImage.scss';
import { mCard, image as mImage } from 'styles/components/common/melodyCard.scss';

const { shortName } = marketplace;

const imageDimensions = { width: 500, height: 500, autoCrop: true };

const ProductImage = ({ item, className, dataTe }, { testId }) => {
  const {
    imageId,
    imageUrl,
    image: { defaultUrl } = {},
    egc,
    asin,
    productId,
    brandName,
    brand,
    style,
    productName
  } = item;

  let link = '';
  let alt = '';

  const parsedImageId = imageId ? imageId : (imageUrl || defaultUrl).match(FILE_NAME_NO_EXT)[0];
  const url = constructMSAImageUrl(parsedImageId, imageDimensions);

  if (egc) {
    link = '/egiftcard';
    alt = `${shortName} Gift Card`;
  } else {
    link = asin ? `/p/asin/${asin}` : `/product/${productId}`;
    alt = `${brandName || brand} ${productName || style}`;
  }

  return (
    <div className={cn(css.container, mCard, className)}>
      <Link
        to={link}
        data-te={dataTe || 'TE_CART_PRODUCTCLICKED'}
        data-ted={asin}
        className={mImage}>
        <img src={url} alt={alt} data-test-id={testId('imageSrc')}/>
      </Link>
    </div>
  );
};

ProductImage.contextTypes = {
  testId: PropTypes.func
};

export default ProductImage;
